export function hasParentWithId(el: HTMLElement | null, id: string): boolean {
  return !!el?.closest(`#${id}`);
}
